import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys =
  | 'setTenantAllocation'
  | 'getTenantAllocation'
  | 'setPartnerAllocation'
  | 'getPartnerAllocation'
  | 'partnerGetOwnAllocation'
  | 'partnerSetTenantAllocation'
  | 'partnerGetTenantAllocation'
  | 'tenantGetOwnAllocation'
  | 'setSubjectAllocation'
  | 'setSubjectAllocationsBatch'
  | 'getSubjectAllocation'
  | 'setMemberQuotaDefault'
  | 'getMemberQuotaDefault';

export function buildAllocationsMethods(ctx: AdminClientContext) {
  const { transport, token, idemKey } = ctx;

  return {
    setTenantAllocation: (tenantId, input, idempotencyKey) =>
      transport.setTenantAllocation(token(), {
        tenantId,
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    getTenantAllocation: (tenantId) =>
      transport.getTenantAllocation(token(), tenantId),
    setPartnerAllocation: (partnerId, input, idempotencyKey) =>
      transport.setPartnerAllocation(token(), {
        partnerId,
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    getPartnerAllocation: (partnerId) =>
      transport.getPartnerAllocation(token(), partnerId),
    partnerGetOwnAllocation: () => transport.partnerGetOwnAllocation(token()),
    partnerSetTenantAllocation: (tenantId, input, idempotencyKey) =>
      transport.partnerSetTenantAllocation(token(), {
        tenantId,
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    partnerGetTenantAllocation: (tenantId) =>
      transport.partnerGetTenantAllocation(token(), tenantId),
    tenantGetOwnAllocation: () => transport.tenantGetOwnAllocation(token()),
    setSubjectAllocation: (granteeKind, granteeId, input, idempotencyKey) =>
      transport.setSubjectAllocation(token(), {
        granteeKind,
        granteeId,
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    setSubjectAllocationsBatch: (input, idempotencyKey) =>
      transport.setSubjectAllocationsBatch(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    getSubjectAllocation: (granteeKind, granteeId) =>
      transport.getSubjectAllocation(token(), granteeKind, granteeId),
    setMemberQuotaDefault: (input, idempotencyKey) =>
      transport.setMemberQuotaDefault(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    getMemberQuotaDefault: (nodeKind, nodeId) =>
      transport.getMemberQuotaDefault(token(), nodeKind, nodeId),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
